import { useEffect, useState } from "react";
import client from "@/lib/api";

const MSG = "Namaste VerB team, mujhe madad chahiye";
let cache = null;
let pending = null;

const load = (fresh) => {
  if (!fresh && cache) return Promise.resolve(cache);
  if (!fresh && pending) return pending;
  pending = client.get("/site/help-contact", { __quiet: true }).then((r) => (cache = r.data)).finally(() => { pending = null; });
  return pending;
};

export const helpWaUrl = (h) => (h?.whatsapp ? `https://wa.me/${h.whatsapp}?text=${encodeURIComponent(MSG)}` : "");
export const helpMailUrl = (h) => (h?.email ? `mailto:${h.email}?subject=${encodeURIComponent("VerB Enquiry")}` : "");
export const refreshHelpContact = () => load(true).then((h) => { window.dispatchEvent(new Event("vb:help-contact")); return h; });

// Admin-managed Help email + WhatsApp (GET /api/site/help-contact); null until loaded.
export function useHelpContact() {
  const [h, setH] = useState(cache);
  useEffect(() => {
    let on = true;
    const get = () => load(false).then((x) => on && setH(x)).catch(() => {});
    get();
    window.addEventListener("vb:help-contact", get);
    return () => { on = false; window.removeEventListener("vb:help-contact", get); };
  }, []);
  return h;
}
